type FormatAmountOptions = {
  currency?: string;
  min?: number;
  max?: number;
  showCurrency?: boolean;
  locale?: string;
}

export const formatAmount = (
  price: number,
  { currency = 'USD', min = 0, max = 0, showCurrency = false, locale = 'en-US' }: FormatAmountOptions = {}
) => {
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  }

  if (showCurrency) {
    options.style = 'currency';
    options.currency = currency;
  }

  if (!showCurrency) {
     options.useGrouping = false;
  }

  return new Intl.NumberFormat(locale, options).format(price);
}
